/* Polsk katalog for locale-projects-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'pj.tab.time': 'Rejestracja czasu',
  'pj.tab.overview': 'Przegląd',
  'pj.tab.settings': 'Ustawienia',
  'pj.day.mon': 'Pon',
  'pj.day.tue': 'Wt',
  'pj.day.wed': 'Śr',
  'pj.day.thu': 'Czw',
  'pj.day.fri': 'Pt',
  'pj.day.sat': 'Sob',
  'pj.day.sun': 'Nd',
  'pj.person.fallback': 'ciebie',
  'pj.time.title': 'Rejestracja czasu: {name}',
  'pj.week.label': 'Tydzień {week}',
  'pj.week.word': 'Tydzień',
  'pj.week.pick': 'Wybierz tydzień',
  'pj.week.current': 'Ten tydzień',
  'pj.week.back': 'Trzy tygodnie wstecz',
  'pj.week.forward': 'Trzy tygodnie naprzód',
  'pj.week.prev': 'Poprzedni tydzień',
  'pj.week.next': 'Następny tydzień',
  'pj.month.prev': 'Poprzedni miesiąc',
  'pj.month.next': 'Następny miesiąc',
  'pj.month.entries': 'Zarejestrowane godziny: {month}',
  'pj.month.dayHours': 'Zarejestrowano: {hours}',
  'pj.view.day': 'Dzień',
  'pj.view.week': 'Tydzień',
  'pj.day.empty': 'Brak zarejestrowanych godzin w tym dniu.',
  'pj.table.projectActivity': 'Projekt / czynność',
  'pj.table.sum': 'Suma',
  'pj.table.hours': 'Godziny',
  'pj.row.new': 'Nowy wiersz',
  'pj.row.add': 'Dodaj',
  'pj.row.remove': 'Usuń wiersz',
  'pj.row.pickBoth': 'Wybierz projekt i czynność',
  'pj.select.project': 'Wybierz projekt …',
  'pj.select.activity': 'Wybierz czynność …',
  'pj.select.projectSearch': 'Szukaj projektu …',
  'pj.select.activitySearch': 'Szukaj czynności …',
  'pj.select.projectEmpty': 'Żaden projekt nie pasuje do wyszukiwania.',
  'pj.select.activityEmpty': 'Żadna czynność nie pasuje do wyszukiwania.',
  'pj.project.createAction': 'Utwórz nowy projekt',
  'pj.activity.createAction': 'Utwórz nową czynność',
  'pj.activity.none': 'Projekt nie ma jeszcze czynności. Utwórz ją tutaj.',
  'pj.lock.state.done': 'Rejestracja czasu jest oznaczona jako zakończona do {date} włącznie.',
  'pj.lock.state.open': 'Rejestracja czasu nie jest oznaczona jako zakończona',
  'pj.lock.markWeek': 'Oznacz jako zakończoną do tygodnia {week} włącznie',
  'pj.lock.undo': 'Cofnij',
  'pj.lock.done': 'Rejestracja czasu jest oznaczona jako zakończona do tygodnia {week} włącznie',
  'pj.lock.undone': 'Rejestracja czasu została ponownie otwarta',
  'pj.entry.newTitle': 'Nowa rejestracja czasu',
  'pj.entry.editTitle': 'Edytuj wpis czasu',
  'pj.entry.invoicedLocked': 'Te godziny zostały zafakturowane i nie można ich zmienić. Usuń szkic faktury lub wystaw do niego fakturę korygującą, aby je zwolnić.',
  'pj.entry.periodLocked': 'Rejestracja czasu dla tego okresu jest oznaczona jako zakończona.',
  'pj.entry.invoicedShort': 'Zafakturowane',
  'pj.field.project': 'Projekt',
  'pj.field.activity': 'Czynność',
  'pj.field.hours': 'Liczba godzin',
  'pj.field.date': 'Data',
  'pj.field.description': 'Opis',
  'pj.field.descriptionHint': 'Na co zostały wykorzystane godziny? Tekst pojawi się na fakturze.',
  'pj.field.name': 'Nazwa',
  'pj.field.number': 'Numer',
  'pj.field.customer': 'Klient',
  'pj.field.contact': 'Osoba kontaktowa',
  'pj.field.optional': 'Opcjonalnie',
  'pj.field.defaultActivity': 'Domyślna czynność',
  'pj.field.product': 'Produkt',
  'pj.field.rate': 'Stawka godzinowa',
  'pj.field.start': 'Początek',
  'pj.field.end': 'Koniec',
  'pj.field.color': 'Kolor',
  'pj.field.status': 'Status',
  'pj.overview.title': 'Przegląd godzin',
  'pj.overview.week': 'Przegląd tygodnia',
  'pj.overview.month': 'Przegląd miesiąca',
  'pj.overview.reports': 'Raporty',
  'pj.overview.total': 'Suma zarejestrowanych',
  'pj.overview.billable': 'Do fakturowania: {hours}',
  'pj.overview.weekEntries': 'Zarejestrowane godziny w tygodniu {week}',
  'pj.overview.empty': 'Brak zarejestrowanych godzin w okresie',
  'pj.overview.emptyTitle': 'Brak godzin',
  'pj.filter.all': 'Wszystkie',
  'pj.filter.period': 'Okres',
  'pj.filter.billing': 'Fakturowanie',
  'pj.filter.billable': 'Do fakturowania',
  'pj.filter.nonBillable': 'Nie',
  'pj.filter.invoicedLabel': 'Zafakturowane',
  'pj.filter.invoiced': 'Zafakturowane',
  'pj.filter.open': 'Niezafakturowane',
  'pj.report.title': 'Zarejestrowane godziny {from} – {to}',
  'pj.report.emptyTitle': 'Brak wpisów',
  'pj.report.emptyText': 'Brak godzin w wybranym okresie i filtrze.',
  'pj.report.print': 'Drukuj',
  'pj.report.pdf': 'Pobierz jako PDF',
  'pj.report.pdfTitle': 'Raport godzin',
  'pj.report.pdfError': 'Nie udało się pobrać raportu.',
  'pj.report.pdfUnavailable': 'PDF raportu nie jest połączony z backendem.',
  'pj.report.opening': 'Otwieranie wydruku …',
  'pj.basis.title': 'Podstawa do faktury',
  'pj.basis.projectName': 'Nazwa projektu',
  'pj.basis.searchPlaceholder': 'Projekt, klient …',
  'pj.basis.summary': 'Niezafakturowane wpisy: {count} (od {from} do {to})',
  'pj.basis.selected': 'Wybrane',
  'pj.basis.costs': 'Wydatki do refakturowania',
  'pj.basis.costText': 'Wydatek',
  'pj.basis.costSource': 'Źródło',
  'pj.basis.costAmount': 'Kwota',
  'pj.basis.costEmployee': 'Wydatek pracownika · {name}',
  'pj.basis.costPurchase': 'Zaksięgowany zakup',
  'pj.basis.timesheet': 'Dołącz zestawienie godzin',
  'pj.basis.create': 'Utwórz szkic faktury',
  'pj.basis.created': 'Utworzono szkic faktury dla {project}',
  'pj.basis.pickOne': 'Wybierz co najmniej jeden wpis',
  'pj.basis.error': 'Nie udało się utworzyć szkicu faktury.',
  'pj.basis.emptyTitle': 'Brak niezafakturowanych godzin',
  'pj.basis.emptyText': 'Wszystko jest zafakturowane albo nie zarejestrowano jeszcze godzin do fakturowania w projektach z klientem.',
  'pj.cost.tab': 'Wydatki',
  'pj.cost.title': 'Wydatki projektu',
  'pj.cost.party': 'Pracownik / dostawca',
  'pj.cost.voucher': 'Dokument',
  'pj.cost.openVoucher': 'Zobacz dokument',
  'pj.cost.noVoucher': 'Dokument jest niedostępny',
  'pj.cost.noVoucherHelp': 'Do tego kosztu nie dołączono pliku.',
  'pj.cost.noVoucherShort': 'Bez dokumentu',
  'pj.cost.pending': 'Do zatwierdzenia',
  'pj.cost.invoiced': 'Zafakturowane',
  'pj.cost.notBillable': 'Nie do fakturowania',
  'pj.cost.toInvoice': 'Do zafakturowania',
  'pj.cost.searchLabel': 'Szukaj',
  'pj.cost.searchPlaceholder': 'Opis, pracownik, dostawca …',
  'pj.cost.openSum': 'Do zafakturowania: {amount}',
  'pj.cost.totalAll': 'Suma wszystkich wyników',
  'pj.cost.emptyTitle': 'Brak wydatków',
  'pj.cost.emptyText': 'Żadne koszty nie są jeszcze powiązane z projektem. Dokumenty powiązuje się z projektem w skrzynce odbiorczej, przy zakupie lub gdy pracownik zgłasza wydatek.',
  'pj.billing.always': 'Zawsze',
  'pj.billing.ask': 'Pytaj',
  'pj.billing.never': 'Nigdy',
  'pj.activity.newTitle': 'Nowa czynność',
  'pj.activity.editTitle': 'Edytuj czynność',
  'pj.activity.namePlaceholder': 'Np. Usługi doradcze',
  'pj.activity.noProduct': 'Brak',
  'pj.activity.productHint': 'Godziny są fakturowane jako „{product}” i księgowane na koncie {account}.',
  'pj.activity.noProductHint': 'Bez produktu godziny są księgowane jako sprzedaż usług na koncie 3020 według standardowej stawki VAT.',
  'pj.activity.rateHint': 'Bez VAT. Jeśli pole pozostanie puste, użyta zostanie cena produktu.',
  'pj.activity.neverHint': 'Godziny są wyłączone z podstawy do faktury. Używaj tego dla urlopów i pracy wewnętrznej.',
  'pj.project.newTitle': 'Utwórz nowy projekt',
  'pj.project.newShort': 'Nowy projekt',
  'pj.project.editTitle': 'Edytuj projekt',
  'pj.project.numberHint': 'Propozycja: {number}',
  'pj.project.customerHint': 'Bez klienta nie można zafakturować godzin.',
  'pj.project.noCustomer': 'Brak klienta (projekt wewnętrzny)',
  'pj.project.closed': 'Zakończony',
  'pj.settings.title': 'Ustawienia rejestracji czasu',
  'pj.settings.activities': 'Czynności',
  'pj.settings.projects': 'Projekty',
  'pj.settings.noActivitiesTitle': 'Brak czynności',
  'pj.settings.noActivitiesText': 'Czynność określa stawkę godzinową i produkt, jako który godziny są fakturowane.',
  'pj.settings.noProjectsFirst': 'Najpierw utwórz projekt.',
  'pj.settings.noProjectsTitle': 'Brak projektów',
  'pj.settings.noProjectsText': 'Utwórz projekt, aby zacząć rejestrować godziny.',
  'pj.toast.entrySaved': 'Godziny zostały zarejestrowane',
  'pj.toast.entryUpdated': 'Wpis czasu został zaktualizowany',
  'pj.toast.entryDeleted': 'Wpis czasu został usunięty',
  'pj.toast.activitySaved': 'Czynność została zapisana',
  'pj.toast.activityDeleted': 'Czynność została usunięta',
  'pj.toast.projectSaved': 'Projekt został zapisany',
  'pj.toast.projectDeleted': 'Projekt został usunięty',
  'pj.error.saveEntry': 'Nie udało się zapisać wpisu czasu.',
  'pj.error.deleteEntry': 'Nie udało się usunąć wpisu czasu.',
  'pj.error.saveRows': 'Nie udało się zaktualizować wierszy.',
  'pj.error.lock': 'Nie udało się zaktualizować blokady.',
  'pj.error.saveActivity': 'Nie udało się zapisać czynności.',
  'pj.error.deleteActivity': 'Nie udało się usunąć czynności.',
  'pj.error.saveProject': 'Nie udało się zapisać projektu.',
  'pj.error.deleteProject': 'Nie udało się usunąć projektu.',
  'pj.validation.projectName': 'Projekt musi mieć nazwę.',
  'pj.validation.endBeforeStart': 'Data zakończenia nie może być wcześniejsza niż data rozpoczęcia.',
  'pj.validation.activityName': 'Czynność musi mieć nazwę.',
  'pj.validation.activityProject': 'Czynność musi należeć do projektu.',
  'pj.validation.entryDate': 'Wpis czasu musi mieć datę.',
  'pj.validation.entryHours': 'Liczba godzin musi być większa od 0.',
  'pj.validation.entryHoursMax': 'Pojedynczy wpis nie może przekraczać 24 godzin.',
  'pj.validation.entryNotFound': 'Nie znaleziono wpisu czasu.',
  'pj.validation.entryInvoiced': 'Wpis czasu został już zafakturowany i nie można go zmienić.',
  'pj.validation.periodLocked': 'Rejestracja czasu dla tego okresu jest oznaczona jako zakończona.',
  'svc.projectNotFound': 'Nie znaleziono projektu.',
  'svc.projectNumberTaken': 'Ten numer projektu jest już używany.',
  'svc.projectHasHours': 'Projekt ma zarejestrowane godziny. Oznacz go jako zakończony zamiast go usuwać.',
  'svc.projectClosed': 'Projekt jest zakończony i nie można do niego dodawać nowych godzin.',
  'svc.projectNeedsCustomer': 'Projekt musi mieć klienta, zanim godziny będzie można zafakturować.',
  'svc.activityNotFound': 'Nie znaleziono czynności.',
  'svc.activityHasHours': 'Czynność ma zarejestrowane godziny i nie można jej usunąć.',
  'svc.timeEntryNotFound': 'Nie znaleziono wpisu czasu.',
  'svc.timeTrackingLocked': 'Rejestracja czasu dla tego okresu jest oznaczona jako zakończona.',
  'svc.pickTimeEntries': 'Wybierz co najmniej jeden niezafakturowany wpis czasu.',
  'svc.timesheetInvoiceDescription': 'Godziny w projekcie {project} w okresie {from} – {to}.',
});
